import { Shrink, Expand } from 'lucide-react';
import useUIStore from '../store/useUIStore';

export default function DensityToggle() {
  const { density, setDensity } = useUIStore();

  return (
    <div className="flex items-center gap-1 rounded-lg border border-border bg-muted p-1">
      <button
        onClick={() => setDensity('comfort')}
        className={`control-inline-compact rounded-md transition-colors ${
          density === 'comfort'
            ? 'bg-card shadow-sm text-primary'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        title="Comfort Density"
      >
        <Expand className="h-4 w-4" />
      </button>
      <button
        onClick={() => setDensity('compact')}
        className={`control-inline-compact rounded-md transition-colors ${
          density === 'compact'
            ? 'bg-card shadow-sm text-primary'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        title="Compact Density"
      >
        <Shrink className="h-4 w-4" />
      </button>
    </div>
  );
}
